export default "__VITE_ASSET__CO8j$sQ4__"